import { useState, useEffect } from 'react'
import { Carousel, Grid, Image } from 'antd'
import type SwiperCore from 'swiper'
import NavBar from 'src/layouts/Navbar'

import { useClickAway } from 'src/shared/hooks/useClickAway'
import { Banner } from 'src/interfaces/structure'
import Modal from 'src/shared/components/Modal'

import { EachSliderStyled, SliderStyled } from './styles'

interface IProps {
  images: Banner[] | undefined
  swiperInstance?: SwiperCore
}
const { useBreakpoint } = Grid

export const Slider = (props: IProps) => {
  const { md } = useBreakpoint()
  const [isOpen, setOpen] = useState<boolean>(false)
  const ref = useClickAway<HTMLDivElement>(() => setOpen(false))

  useEffect(() => {
    setOpen(true)
  }, [])

  const slides = props?.images?.map((slide) => {
    return {
      imageUrl: slide.imageUrl,
      imageMobileUrl: slide.imageMobileUrl,
      caption: '',
      customWrap: Boolean(slide?.redirectTo)
        ? (el: React.ReactNode) => (
            <a
              href={slide.redirectTo}
              target={slide.redirectTo.includes('https://') ? '_blank' : '_self'}
              rel="noreferrer"
              key={'customWrap'}
            >
              {el}
            </a>
          )
        : undefined,
    }
  })

  if (!slides?.length) return <div></div>

  return (
    <>
      <NavBar swiperInstance={props.swiperInstance} />
      <SliderStyled>
        <Carousel arrows autoplay={{ dotDuration: true }} autoplaySpeed={3500}>
          {slides?.map((imgItem, index: number) => {
            const el = (
              <EachSliderStyled key={index}>
                <img
                  className="img"
                  src={md ? imgItem.imageUrl : imgItem.imageMobileUrl}
                  alt={imgItem.caption}
                />
              </EachSliderStyled>
            )
            return imgItem?.customWrap?.(el) ?? el
          })}
        </Carousel>
        {/*<Modal ref={ref} isOpen={isOpen} onClose={() => setOpen(false)}>
          <Image width={300} src={'images/notification.png'} preview={false} />
        </Modal>*/}
      </SliderStyled>
    </>
  )
}
